import { useShowDebugInfo } from "../hooks/configuration";

const colors = [
    "#FF5733", // Red-ish
    "#3498db", // Blue
    "#e67e22", // Orange
    "#e74c3c", // Bright Red
    "#95a5a6", // Grey
    "#2ecc71", // Green
    "#9b59b6", // Purple
    "#34495e", // Dark Blue
];

const hashCode = (str: string): number =>
    Array.from(str).reduce((hash, char) => ((hash << 5) - hash + char.charCodeAt(0)) | 0, 0);

// Use the hash to pick a color from the array
const getColorForTag = (tag: string): string => colors[Math.abs(hashCode(tag)) % colors.length];

export const PrimeDebugLog = (tag: string, ...args: any[]) => {
    if (useShowDebugInfo()) {
        const bgColor = getColorForTag(tag);
        const tagStyle = `color: #FFF; background-color: ${bgColor}; padding: 2px 4px; border-radius: 4px;`;
        console.log(`%c${tag}%c `, tagStyle, "", ...args);
    }
};
